<template>
  <v-checkbox
    v-model="inputIsChecked"
    hide-details
    class="check-box"
    color="#74B8BE"
    @change="changeAction"
  ></v-checkbox>
</template>

<script>
export default {
  name: "CheckListItemCheckBox",
  data: () => ({
  }),
  methods: {
    changeAction() {
      this.$emit('checkItemAction')
    }
  },
  computed: {
    inputIsChecked: {
      get() {
        return this.isChecked;
      },
      set(value) {
        this.$emit("update:isChecked", value);
      }
    },
  },
  created() {
  },
  components: {
  },
  props: ["isChecked"]
};

</script>

<style scoped>
.check-box {
  margin: 0 0 0 8px;
}
</style>
